import { EditExpert } from "./edit-expert";

export default EditExpert;
